export const MARGIN = {
  '0': '0',
  '1': '0.25rem',
  '2': '0.5rem',
  '3': '0.75rem',
  '4': '1rem',
  '5': '1.25rem',
  '6': '1.5rem',
  '7': '2rem',
  '8': '2.5rem',
  '9': '3rem',
  '10': '4rem',
  T0: '0 0 0 0',
  T1: '0.25rem 0 0 0',
  T2: '0.5rem 0 0 0',
  T3: '0.75rem 0 0 0',
  T4: '1rem 0 0 0',
  T5: '1.25rem 0 0 0',
  T6: '1.5rem 0 0 0',
  T7: '2rem 0 0 0',
  T8: '2.5rem 0 0 0',
  T9: '3rem 0 0 0',
  T10: '4rem 0 0 0',
  R0: '0 0 0 0',
  R1: '0 0.25rem 0 0',
  R2: '0 0.5rem 0 0',
  R3: '0 0.75rem 0 0',
  R4: '0 1rem 0 0',
  R5: '0 1.25rem 0 0',
  R6: '0 1.5rem 0 0',
  R7: '0 2rem 0 0',
  R8: '0 2.5rem 0 0',
  R9: '0 3rem 0 0',
  R10: '0 4rem 0 0',
  B0: '0 0 0',
  B1: '0 0 0.25rem',
  B2: '0 0 0.5rem',
  B3: '0 0 0.75rem',
  B4: '0 0 1rem',
  B5: '0 0 1.25rem',
  B6: '0 0 1.5rem',
  B7: '0 0 2rem',
  B8: '0 0 2.5rem',
  B9: '0 0 3rem',
  B10: '0 0 4rem',
  L0: '0 0 0 0',
  L1: '0 0 0 0.25rem',
  L2: '0 0 0 0.5rem',
  L3: '0 0 0 0.75rem',
  L4: '0 0 0 1rem',
  L5: '0 0 0 1.25rem',
  L6: '0 0 0 1.5rem',
  L7: '0 0 0 2rem',
  L8: '0 0 0 2.5rem',
  L9: '0 0 0 3rem',
  L10: '0 0 0 4rem',
  X0: '0 0',
  X1: '0 0.25rem',
  X2: '0 0.5rem',
  X3: '0 0.75rem',
  X4: '0 1rem',
  X5: '0 1.25rem',
  X6: '0 1.5rem',
  X7: '0 2rem',
  X8: '0 2.5rem',
  X9: '0 3rem',
  X10: '0 4rem',
  Y0: '0 0',
  Y1: '0.25rem 0',
  Y2: '0.5rem 0',
  Y3: '0.75rem 0',
  Y4: '1rem 0',
  Y5: '1.25rem 0',
  Y6: '1.5rem 0',
  Y7: '2rem 0',
  Y8: '2.5rem 0',
  Y9: '3rem 0',
  Y10: '4rem 0',
};

export default MARGIN;
